module.exports = "/_next/static/images/632a94e7bd4427a7a1bbe53fd00be085-people-working-together@lg-1x.jpg";